import React, { useEffect, useState } from 'react'
import Layout from '../../components/common/pageLayout'
import { toast } from 'react-toastify'
import ProjectList from '../../components/Attendance/myAtendance'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import constant from '../../constant'
import { v3_cofirmMonthlyAttendance, v3_myMonthlyAttendance } from '../../actions/v3/attendance'
import moment from 'moment'
const List = (props) => {

    const [data, setData] = useState([])

    const [selectedMonth, setMonth] = useState(moment().format('YYYY-MM'))
    useEffect(() => {
        v3_myMonthlyAttendance(moment(selectedMonth).format('MM'), moment(selectedMonth).format('YYYY')).then((res) => {
            if (res.status) {
                setData(res.result.projects);
                props.history.push(constant.Authedcomponent.myAttendance.url);
            }
            else {
                toast.error(res.error)
            }
        })
    }, [selectedMonth])

    const onSubmit = (model) => {

        v3_cofirmMonthlyAttendance({
            ...model,
            month: moment(selectedMonth).format('MM'),
            year: moment(selectedMonth).format('YYYY')
        }).then((res) => {
            if (res.status) {
                v3_myMonthlyAttendance(moment(selectedMonth).format('MM'), moment(selectedMonth).format('YYYY')).then((res) => {
                    if (res.status) {
                        setData(res.result.projects);
                        props.history.push(constant.Authedcomponent.myAttendance.url);
                    }
                    else {
                        toast.error(res.error)
                    }
                })
            }
            else {
                toast.error(res.error)
            }
        })
    }

    return (
        <Layout
            title={`Monthly Attendance`}
        >

            <div className="d-flex justify-content-between align-items-center mb-3">
                <h4>Attendance Sheet</h4>
                <input
                    type="month"
                    className="form-control"
                    style={{ width: "200px" }}
                    value={selectedMonth}
                    onChange={(e) => { setMonth(e.target.value) }}
                />
            </div>
            {data && <ProjectList
                onSubmit={onSubmit}
                projects={data}
                month={moment(selectedMonth).format('MM')}
                year={moment(selectedMonth).format('YYYY')}
            />}
        </Layout>
    )
}

export default List